/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
// gatsby-browser.js
import './src/styles/global.css';

export const wrapPageElement = ({ element }) => {
  return element;
};

// gatsby-browser.js
export const onRouteUpdate = ({ location }) => {
  // Forces Gatsby to re-evaluate the 404 page on every unknown route
  if (typeof window !== "undefined") {
    window.__gatsbyNotFound = true;
  }
};
